import React from "react";
import classNames from "classnames";
import { ICommand } from "Application";
import { StyledActionBtn, ButtonSpinner } from "./ActionButton.styles";

interface ActionButtonProps {
    command: ICommand;
    commandParam?: any;
    loading?: boolean;
    disabled?: boolean;
    children: React.ReactNode;
    className?: string;
}

export const ActionButton: React.FC<ActionButtonProps> = ({ command, commandParam, loading = false, disabled = false, children, className }) => (
    <StyledActionBtn onClick={() => command.execute(commandParam)} disabled={loading || disabled} type="button" className={classNames({ loading }, className)}>
        {loading ? <ButtonSpinner /> : children}
    </StyledActionBtn>
);
